import "./App.css";
import "./styles/AppLayout.css";
import { useState, useEffect } from "react";
import CpfValidationModal from "./components/CpfValidationModal";
import SchedulePage from "./components/SchedulePage";
import Footer from "./components/Footer";

function App() {
  const path = window.location.pathname;
  const quoteUuid = path.split("/")[1];

  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setIsAuthorized(true);
    }
  }, []);

  const handleValidationSuccess = () => {
    setIsAuthorized(true);
  };

  if (!isAuthorized) {
    return <CpfValidationModal onValidationSuccess={handleValidationSuccess} />;
  }

  return (
    <div className="app-layout">
      <main className="app-layout__content">
        <SchedulePage uuid={quoteUuid} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
